/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JumboStructsGCPServiceAccount
 */
export interface JumboStructsGCPServiceAccount {
    /**
     * 
     * @type {string}
     * @memberof JumboStructsGCPServiceAccount
     */
    auth_provider_x509_cert_url?: string;
    /**
     * 
     * @type {string}
     * @memberof JumboStructsGCPServiceAccount
     */
    auth_uri?: string;
    /**
     * 
     * @type {string}
     * @memberof JumboStructsGCPServiceAccount
     */
    client_email?: string;
    /**
     * 
     * @type {string}
     * @memberof JumboStructsGCPServiceAccount
     */
    client_id?: string;
    /**
     * 
     * @type {string}
     * @memberof JumboStructsGCPServiceAccount
     */
    client_x509_cert_url?: string;
    /**
     * 
     * @type {string}
     * @memberof JumboStructsGCPServiceAccount
     */
    private_key?: string;
    /**
     * 
     * @type {string}
     * @memberof JumboStructsGCPServiceAccount
     */
    private_key_id?: string;
    /**
     * 
     * @type {string}
     * @memberof JumboStructsGCPServiceAccount
     */
    project_id?: string;
    /**
     * 
     * @type {string}
     * @memberof JumboStructsGCPServiceAccount
     */
    token_uri?: string;
    /**
     * 
     * @type {string}
     * @memberof JumboStructsGCPServiceAccount
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof JumboStructsGCPServiceAccount
     */
    universe_domain?: string;
}

/**
 * Check if a given object implements the JumboStructsGCPServiceAccount interface.
 */
export function instanceOfJumboStructsGCPServiceAccount(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function JumboStructsGCPServiceAccountFromJSON(json: any): JumboStructsGCPServiceAccount {
    return JumboStructsGCPServiceAccountFromJSONTyped(json, false);
}

export function JumboStructsGCPServiceAccountFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboStructsGCPServiceAccount {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'auth_provider_x509_cert_url': !exists(json, 'auth_provider_x509_cert_url') ? undefined : json['auth_provider_x509_cert_url'],
        'auth_uri': !exists(json, 'auth_uri') ? undefined : json['auth_uri'],
        'client_email': !exists(json, 'client_email') ? undefined : json['client_email'],
        'client_id': !exists(json, 'client_id') ? undefined : json['client_id'],
        'client_x509_cert_url': !exists(json, 'client_x509_cert_url') ? undefined : json['client_x509_cert_url'],
        'private_key': !exists(json, 'private_key') ? undefined : json['private_key'],
        'private_key_id': !exists(json, 'private_key_id') ? undefined : json['private_key_id'],
        'project_id': !exists(json, 'project_id') ? undefined : json['project_id'],
        'token_uri': !exists(json, 'token_uri') ? undefined : json['token_uri'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'universe_domain': !exists(json, 'universe_domain') ? undefined : json['universe_domain'],
    };
}

export function JumboStructsGCPServiceAccountToJSON(value?: JumboStructsGCPServiceAccount | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'auth_provider_x509_cert_url': value.auth_provider_x509_cert_url,
        'auth_uri': value.auth_uri,
        'client_email': value.client_email,
        'client_id': value.client_id,
        'client_x509_cert_url': value.client_x509_cert_url,
        'private_key': value.private_key,
        'private_key_id': value.private_key_id,
        'project_id': value.project_id,
        'token_uri': value.token_uri,
        'type': value.type,
        'universe_domain': value.universe_domain,
    };
}

